import { render, staticRenderFns } from "./deleteBlockDialog.vue?vue&type=template&id=12bf8095&scoped=true"
import script from "./deleteBlockDialog.vue?vue&type=script&lang=js"
export * from "./deleteBlockDialog.vue?vue&type=script&lang=js"
import style0 from "./deleteBlockDialog.vue?vue&type=style&index=0&id=12bf8095&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bf8095",
  null
  
)

export default component.exports